import { ref, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

export interface ActiveReservationInfo {
  tenantId: string
  tableNo: string
  reservationId: string
  /** Used for check_reservation_host on refresh and before place order */
  reservationNumber?: string
}

export function useActiveReservation() {
  const authStore = useAuthStore()
  const loading = ref<boolean>(false)
  const activeReservationInfo = ref<ActiveReservationInfo | null>(null)

  // Check if user has active reservation stored in localStorage
  const getStoredActiveReservation = (): ActiveReservationInfo | null => {
    const stored = localStorage.getItem('active_reservation_info')
    if (stored) {
      try {
        return JSON.parse(stored) as ActiveReservationInfo
      } catch {
        return null
      }
    }
    return null
  }

  // Check if user has any active reservation
  const hasActiveReservation = computed(() => {
    return !!(
      authStore.isAuthenticated &&
      authStore.activeReservationId &&
      getStoredActiveReservation()
    )
  })

  return {
    loading,
    activeReservationInfo,
    hasActiveReservation,
    getStoredActiveReservation,
  }
}
